import * as React from "react";
import { forwardRef } from "react";
const SvgDragable = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 6.5, width: 18, height: 1, rx: 0.5, fill: "#090909", fillOpacity: 0.5 }), /* @__PURE__ */ React.createElement("rect", { x: 3, y: 11.5, width: 18, height: 1, rx: 0.5, fill: "#090909", fillOpacity: 0.5 }), /* @__PURE__ */ React.createElement("rect", { x: 3, y: 16.5, width: 18, height: 1, rx: 0.5, fill: "#090909", fillOpacity: 0.5 }));
const ForwardRef = forwardRef(SvgDragable);
export default ForwardRef;
